import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';
export default function CalendarTransferLogsGridToolbar() {
  const apiRef = useGridApiContext();

  return (
    <SharedToolbar
      secondaryButtons={
        <>
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              if (apiRef.current?.dataSource?.fetchRows) {
                apiRef.current.dataSource.cache.clear();
                apiRef.current.setPaginationModel({
                  page: 0,
                  pageSize: 50,
                });
                apiRef.current.dataSource.fetchRows();
              }
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="calendarTransferLogsGridStates"
            module={ModuleList.modules.calendars.name}
            section={ModuleList.modules.calendars.sections.calendarTransferLogs}
          />
        </>
      }
    />
  );
}
